export default __webpack_public_path__ + "static/media/nft15.ed36811d.png";